<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="550">
      <v-card>
        <v-card-title class="pb-0">
          <v-spacer></v-spacer>
          <v-btn class="ma-0" depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="confirm_form" data-vv-scope="confirm_form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-icon size="150" :color="type && typeColors[type] ? typeColors[type] : 'error'" class="">{{ type === 'success' ? 'check_circle' : 'error_outline'}}</v-icon>
              </v-flex>
              <v-flex xs12 text-xs-center headline>
                {{ alertTitle }}
              </v-flex>
              <v-flex xs12 text-xs-center subheading mt-3>
                <span v-html="alertText"></span>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="type === 'perms'">
            <v-btn flat @click="dialog = false" class="mx-2">בטל</v-btn>
            <v-btn
              v-if="
                $store.state.user.projects_count < 5 &&
                $store.state.user.keywords_count < 400
              "
              color="warning"
              @click="$eventEmitter.$emit('wizardDialog', true);"
            >שדרג חבילה</v-btn>
            <!-- Configure Package -->
            <v-btn color="info" @click="dialog = false;" href="https://app.kolyom.co.il/" target="_blank">נסה את מערכת כליום</v-btn>
          </template>
          <template v-else-if="type === 'login'">
            <v-btn flat @click="dialog = false">בטל</v-btn>
            <v-btn color="warning" @click="dialog = false; $router.push({name: 'Login'})">לחץ להירשם בחינם!</v-btn>
          </template>
          <template v-else-if="type === 'tenClub'">
            <v-btn flat @click="dialog = false">בטל</v-btn>
            <SendOfferModal></SendOfferModal>
          </template>
          <v-btn v-else flat color="info" @click="dialog = false">בטל</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'AlertModal',
  props: ['alertModalDialog', 'type', 'alertTitle', 'alertText'],
  data () {
    return {
      dialog: this.alertModalDialog,
      typeColors: {
        error: 'error',
        warning: 'warning',
        success: 'success',
        info: 'info',
        perms: 'warning',
        login: 'warning',
        tenClub: 'warning'
      }
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
    alertModalDialog: {
      handler () {
        this.dialog = this.alertModalDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('alertModalDialog', this.dialog)
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/alerts/AlertModal.vue